import {isLoggedIn} from '../../utils/auth'
import {injectReducer} from "../../store/reducers";

export default (store) => ({
  path: 'lead-management-reports',
  onEnter: isLoggedIn(store),
  /*  Async getComponent is only invoked when route matches   */
  getComponent(nextState, cb) {
    /*  Webpack - use 'require.ensure' to create a split point
        and embed an async module loader (jsonp) when bundling   */
    require.ensure([], (require) => {
      /*  Webpack - use require callback to define
          dependencies for bundling   */
      const leadManagementCategoryWiseReportContainer = require('./containers/LeadManagementCategoryWiseReportContainer').default
      const {loadBrandNamesReducer, loadStoreOptionsReducer, loadStoreTagOptionsReducer} = require('../SalesAnalytics/modules/salesAnalytics')
      const {filterValuesReducer} = require("../Home/modules/home");
      const {loadLeadReportDataReducer} = require('./modules/LeadManagementCategoryWiseReportReducer')
      injectReducer(store, {key: 'filter', reducer: filterValuesReducer});
      injectReducer(store, {key: 'brands', reducer: loadBrandNamesReducer})
      injectReducer(store, {key: 'reportData', reducer: loadLeadReportDataReducer})
      // injectReducer(store, {key: 'storeOptions', reducer: loadStoreOptionsReducer})
      // injectReducer(store, {key: 'storeTagOptions', reducer: loadStoreTagOptionsReducer})

      cb(null, leadManagementCategoryWiseReportContainer)
      /* Webpack named bundle   */
    }, 'leadManagementCategoryWiseReportContainer')
  }
})



// WEBPACK FOOTER //
// ./src/routes/LeadManagementCategoryWiseReport/index.js